<template>
  <div
    ref="frame"
    class="auth-showcase-preview"
  >
    <div
      class="auth-showcase-preview__viewport"
      :style="{ width: `${stageWidth * scale}px`, height: `${stageHeight * scale}px` }"
    >
      <div
        class="auth-showcase-preview__stage"
        :style="{ width: `${stageWidth}px`, height: `${stageHeight}px`, transform: `scale(${scale})` }"
      >
        <auth-showcase :preview-slides="slides" />
      </div>
    </div>
  </div>
</template>

<script>
import AuthShowcase from '@/components/auth/AuthShowcase.vue'

export default {
  components: {
    AuthShowcase,
  },

  props: {
    slides: {
      type: Array,
      required: true,
    },
    maxHeight: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      stageWidth: 620,
      stageHeight: 740,
      scale: 0.6,
      observer: null,
    }
  },

  watch: {
    maxHeight() {
      this.measure()
    },
  },

  mounted() {
    this.measure()
    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(this.measure)
      this.observer.observe(this.$refs.frame)
    } else {
      window.addEventListener('resize', this.measure)
    }
  },

  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
    window.removeEventListener('resize', this.measure)
  },

  methods: {
    measure() {
      const width = this.$refs.frame ? this.$refs.frame.clientWidth : 0
      if (!width) return
      const limits = [1, width / this.stageWidth]
      if (this.maxHeight) limits.push(this.maxHeight / this.stageHeight)
      this.scale = Math.min(...limits)
    },
  },
}
</script>

<style lang="scss" scoped>
.auth-showcase-preview {
  width: 100%;
}

.auth-showcase-preview__viewport {
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 14px;
  background: #0b0f14;
}

.auth-showcase-preview__stage {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: top left;
}
</style>
